//#region import libraries
import React, { useEffect, useState } from "react";
import { Toggle, ToggleItem } from "@tremor/react";
// custom components
import { MessageInput, EmptyScreen } from "_atoms";
import { PassengerMessage, PassengerChat, ChatHeader } from "_molecules";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
  getConversations,
  getMessages,
  selectConversations,
  selectSelectedConversation,
  selectMessage,
  setMessage,
  postMessage,
  clearSelectedConversation,
  selectSendMessageStatus,
  postNotification,
  setShowArchive,
  selectShowArchive,
  updateSupportDesk,
  selectSupportDesk
} from "_redux/slices/messaging/messaging";
import { selectFirebaseUser, selectIata, selectUserDb } from "_redux/slices/main-screen/user";
import { selectAirportInformation, } from "_redux/slices/analytics/reviews";

// bootstrap //
import { Container, Col, Row } from "react-bootstrap";

// firestore
import { firestore } from "_utils/firebase-app";
import { collection, onSnapshot } from "firebase/firestore";

// styles
import { Colors, Spacing } from "_styles";
//#endregion


const MessagingPage = (props) => {
  //#region local state
  const [firstRender, setFirstRender] = useState(true); // true if first render of screen
  const [cachedLastMessage, setCachedLastMessage] = useState(""); // true if settings icon clicked
  const [airportName, setAirportName] = useState("");
  //#endregion

  //#region redux
  const dispatch = useDispatch();
  const conversations = useSelector(selectConversations); // list of chats
  const selectedConversation = useSelector(selectSelectedConversation); // currently selected chat
  const message = useSelector(selectMessage); // currently typed message
  const sendMessageStatus = useSelector(selectSendMessageStatus); // status of sending message

  const supportDesk = useSelector(selectSupportDesk);

  // user info
  const user = useSelector(selectFirebaseUser);
  const dbUser = useSelector(selectUserDb);
  const showArchive = useSelector(selectShowArchive);

  // airport info
  const iata = useSelector(selectIata);
  const airportInformation = useSelector(selectAirportInformation);
  //#endregion

  // message handler
  const sendMessage = () => {
    let tempSelectedConversationId = selectedConversation.id;
    let tempCopy = { ...supportDesk, lastOnline: new Date().toISOString() };

    dispatch(
      postMessage({
        message,
        userId: user.uid,
        tempSelectedConversationId,
        iata,
      })
    );
    dispatch(updateSupportDesk(tempCopy));
    setCachedLastMessage(message); // used in notification message
    dispatch(setMessage(""));
  };

  const toggleFilter = (value) => {
    dispatch(setShowArchive(value));
    dispatch(clearSelectedConversation());
  };

  //#region use effects
  // get conversations on render
  useEffect(() => {
    //console.log('getting conversatiinso', iata)
    dispatch(getConversations({ iata }));
    dispatch(clearSelectedConversation()); // clear selected conversation
  }, []);

  // notification listener
  useEffect(() => {
    if (
      selectedConversation &&
      selectedConversation.id &&
      selectedConversation.id.split("-") &&
      selectedConversation.id.split("-")[0] &&
      !firstRender
    ) {
      if (sendMessageStatus == "succeeded") {
        let title = airportName
          ? "New Support Desk Message from " + airportName
          : "New Support Desk Message";
        let subtitle =
          cachedLastMessage.length > 0 ? cachedLastMessage : "New Message";

        // on sending a message send notification
        dispatch(
          postNotification({
            userId: selectedConversation.id.split("-")[0],
            notificationTitle: title,
            notificationText: subtitle,
            notificationType: "support-desk",
            iata:
              dbUser.details.authority != undefined
                ? dbUser.details.authority
                : "null",
          })
        );
      }
    }
  }, [sendMessageStatus]);

  useEffect(() => {
    if (selectedConversation) {
      console.log("selected convresation: ", selectedConversation);
    }
  }, [selectedConversation]);

  // message listener
  useEffect(() => {
    if (selectedConversation) {
      let isFirstSnapshot = true; // Flag to check if it's the first snapshot
      const unsubscribe = onSnapshot(
        collection(
          firestore,
          `conversations/${selectedConversation.id}/messages`
        ),
        (snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              const newMessage = change.doc.data();

              if (!isFirstSnapshot) {
                dispatch(
                  getMessages({ conversation: selectedConversation.id })
                );
              }
            }
          });

          isFirstSnapshot = false; // Update the flag after the first snapshot
        }
      );

      return () => unsubscribe();
    }
  }, [selectedConversation]);

  useEffect(() => {
    if (
      airportInformation &&
      dbUser &&
      dbUser.details &&
      dbUser.details.authority &&
      airportInformation[dbUser.details.authority] &&
      airportInformation[dbUser.details.authority].name
    ) {
      setAirportName(airportInformation[dbUser.details.authority].name);
    }
  }, [airportInformation]);

  useEffect(() => {
    setFirstRender(false);
  }, []);
  //#endregion

  const height = "70vh"; // fixed height of chat


  return (
    // <LoadingScreenContainer loading={fetchConversationStatus == 'loading' || fetchNameStatus == 'loading' ? true : false}>
    <Container className="mt-3">
      {/* Main Messaging Screen */}
      <Row style={{ height: height, borderRadius: 5 }}>
        {/* Sidebar */}
        <Col
          xs={3}
          style={{
            height: "100%",
            borderRightWidth: 1,
            borderStyle: "solid",
            borderLeftWidth: 1,
            borderTopWidth: 0,
            borderBottomWidth: 1,
            borderColor: Colors.GRAY_LIGHT,
          }}
        >
          {/* Active / Archived Chats Toggle */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            className="mt-2"
          >
            <Toggle
              color="zinc"
              defaultValue={showArchive}
              onValueChange={(value) => toggleFilter(value)}
            >
              <ToggleItem value={false} text="Active Chats" />
              <ToggleItem value={true} text="Archived Chats" />
            </Toggle>
            {/*<FiSettings onClick={openSettings} size={22} style={{ color: 'black', opacity: 0.4, cursor: 'pointer', alignSelf: 'flex-end',}} /> */}
          </div>

          {/*<div className="mt-2" style={{ borderWidth:1, borderRadius:5, borderColor:Colors.GRAY_LIGHT, borderStyle:'solid'}}>
            <TextInput value={searchTerm} onChange={(e)=>{ dispatch(setSearch(e.target.value))}} icon={IoSearchSharp} placeholder="Search..." />
          </div>*/}

          {/* List of Conversations */}
          <div
            style={{
              "overflow-y": "scroll",
              height: "90%",
              padding: Spacing.SCALE_12,
              marginTop: Spacing.SCALE_22,
            }}
          >
            {conversations.map((conversation) => {
              return <PassengerMessage conversation={conversation} />;
            })}
          </div>
        </Col>

        {/* Chat */}
        <Col>
          {selectedConversation != undefined ||
            (selectedConversation != null &&
              conversations &&
              conversations.length != 0) ? (
            <Row style={{ height: height }}>
              {/* Header */}
              <ChatHeader />

              {/* Messages */}
              <PassengerChat />

              {/* Message Input */}
              <MessageInput
                onChange={(e) => {
                  dispatch(setMessage(e.target.value));
                }}
                onKeyPress={(e) => {
                  if (e.key == "Enter") {
                    sendMessage();
                  }
                }}
                value={message}
                onClick={() => {
                  sendMessage();
                }}
              />
            </Row>
          ) : /* No Selected Conversation */
            selectedConversation == null && conversations.length > 0 ? (
              <EmptyScreen></EmptyScreen>
            ) : conversations != undefined &&
              conversations.length != undefined &&
              conversations.length == 0 &&
              showArchive ? (
              <EmptyScreen></EmptyScreen>
            ) : conversations != undefined &&
              conversations.length != undefined &&
              conversations.length == 0 &&
              !showArchive ? (
              <EmptyScreen></EmptyScreen>
            ) : (
              ""
            )}
        </Col>
      </Row>
    </Container>
    // </LoadingScreenContainer>
  );
};

export default MessagingPage;
